function formatId(id) {
  const idFormat = id.toString().padStart(5, 0);
  return `CS-${idFormat}`;
}

export default formatId;
